import 'twin.macro';
import DOMPurify from 'dompurify';

import { Loader } from '@components/Loader';
import aiLoader from '@assets/images/ai-loader.gif';
import {
  PROMOTION_VIEW_ITEMS,
  useEpisodeDetailsContext,
} from '@insights_module/context/EpisodeDetailsContext';
import { GenerateAIContentButton } from '@insights_module/components/episode_details_screen/GenerateAIContentButton';
import { useEpisodeDetailsData } from '@insights_module/hooks/useEpisodeDetailsData';

const SanitizedHTML = ({ htmlString }: { htmlString: string }) => {
  const cleanHtmlString = DOMPurify.sanitize(htmlString);
  return (
    <div
      css={{
        'h1, h2, h3, h4, h5, h6, p': {
          fontSize: '18px',
          textAlign: 'left',
          lineHeight: '24px',
          color: 'var(--text-and-icon)',
        },
        ul: {
          paddingLeft: '16px',
        },
        li: {
          listStyleType: 'disc',
          color: 'var(--text-and-icon)',
        },

        p: { fontSize: '16px' },
      }}
      dangerouslySetInnerHTML={{ __html: cleanHtmlString }}
    />
  );
};

export const EpisodePromotionItem = () => {
  const { activeView } = useEpisodeDetailsContext();

  const { isLoading, selectedPromotionItem, selectedPromotionItemIsGenerating } =
    useEpisodeDetailsData();

  if (!PROMOTION_VIEW_ITEMS.includes(activeView)) return null;

  if (!selectedPromotionItem?.value && !selectedPromotionItemIsGenerating) {
    return (
      <div tw='px-[24px] py-[16px] w-full text-text-and-icon'>
        <div tw='flex flex-col w-full h-[200px] justify-center items-center gap-[24px]'>
          {isLoading ? (
            <Loader size='lg' theme='dark' />
          ) : (
            <>
              AI content is not generated for this episode.
              <GenerateAIContentButton />
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div tw='px-[24px] py-[16px] w-full text-text-and-icon'>
      {!selectedPromotionItem?.value && (
        <div tw='flex w-full h-[200px] justify-center items-center'>
          {selectedPromotionItemIsGenerating ? (
            <div tw='flex flex-col items-center justify-center'>
              <img src={aiLoader} alt='ai-loader' width={150} />
              <span>Magic in motion...</span>
            </div>
          ) : (
            'No promotion item generated.'
          )}
        </div>
      )}
      {!!selectedPromotionItem?.value && <SanitizedHTML htmlString={selectedPromotionItem.value} />}
    </div>
  );
};
